import { POSITION, useToast } from 'vue-toastification';

import TemplateNotification from './templateNotification.vue';

const toast = useToast();

export const typesNotification = {
  error: 'error',
  success: 'success',
  warning: 'warning',
  info: 'info',
  default: 'default',
};

export const openNotification = (type, msg, duration) => {
  toast(<TemplateNotification msg={msg} />, {
    position: POSITION.TOP_RIGHT,
    type: type,
    timeout: duration ? duration : type !== 'error' ? 3000 : 4000,
    closeButton: false,
  });
};
